export const toastrOptions = {
  closeButton: true,
  closeHtml: '<button><i class="hui-i hui-svg-toastr-close"></i></button>',
  debug: false,
  newestOnTop: false,
  progressBar: false,
  positionClass: 'hui-toast',
  preventDuplicates: false,
  onclick: null,
  showDuration: '300',
  hideDuration: '1000',
  timeOut: '5000',
  extendedTimeOut: '1000',
  showEasing: 'swing',
  hideEasing: 'linear',
  showMethod: 'fadeIn',
  hideMethod: 'fadeOut',
};
